import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import { fitToPage, goToPage } from '@/hooks/paging';
import TableHeader from '@/components/table/TableHeader';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import { buildColumns } from '../helper';
import AuditsTableColumns from './AuditsTableColumns';
import AuditsTableRows from './AuditsTableRows';
import AuditEntityFilter from './AuditEntityFilter';
import AuditPanelHeader from './AuditPanelHeader';
import AuditsTableSettingsMenu from './AuditsTableSettingsMenu';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const AuditsTable = ({ category, code }) => {
  const state = Selectors.useAuditsTable({ category, code });
  const fetchData = Events.useFetchAudits(category, { code });
  const columns = buildColumns(category);
  const { items, pageNumber } = fitToPage(state.audits, state.currentPage, state.pageSize);
  const ref = React.useRef(null);

  return (
    <div className="ReactTable" ref={ref}>
      <TableWrapper sticky celled className="aridhia-audits-table">
        <Table.Header fullWidth>
          <TableHeader
            isLoading={code ? false : state.readStatus === states.PENDING}
            error={firstErrorMessage(state.readErrors)}
            numberOfColumns={columns.length}
            loaderButton
          >
            {code && (<AuditPanelHeader value={state.name} category={category} code={code} />)}
            {(code || state.readStatus === states.SUCCESS) && (
            <AuditsTableSettingsMenu
              category={category}
              code={code}
              isLoading={!code ? false : state.readStatus === states.PENDING}
              pointingPosition={code ? 'right' : 'left'}
            />
            )}
            {!code && (
            <AuditEntityFilter
              category={category}
              code={code}
              className="aridhia-table-filter"
              error={firstErrorMessage(state.readErrors)}
            />
            )}
          </TableHeader>
          <AuditsTableColumns category={category} code={code} items={items} columns={columns} />
        </Table.Header>
        <Table.Body>
          <AuditsTableRows category={category} columns={columns} items={items} />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        currentPage={pageNumber}
        entity="audit"
        icon="history"
        goToPage={(args) => goToPage(fetchData, args, ref)}
        items={items}
        pageCount={state.pageCount}
        readErrors={state.readErrors}
        readStatus={state.readStatus}
        total={state.total}
      />
    </div>
  );
};

export default AuditsTable;
